import { render, staticRenderFns } from "./UserCardList.vue?vue&type=template&id=242ed145&scoped=true"
import script from "./UserCardList.vue?vue&type=script&lang=js"
export * from "./UserCardList.vue?vue&type=script&lang=js"
import style0 from "./UserCardList.vue?vue&type=style&index=0&id=242ed145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242ed145",
  null
  
)

export default component.exports